import { useState } from "react";
import { useT } from "@/i18n/I18nContext";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle,
} from "@/components/ui/dialog";
import { Search, Check, X } from "lucide-react";

// Compact sheet listing multiple foods detected by the voice parser.
// User taps a row → parent opens the FoodSearchDialog for that item.
// Rows show a green check once their food has been logged.
//
// Props:
//   open           bool
//   onOpenChange   (bool) → void
//   items          [{query, quantity_g?, pieces?, done?}, ...]
//   onPickItem     (item, index) → void   — parent opens the search dialog
export default function VoiceMultiSheet({ open, onOpenChange, items = [], onPickItem }) {
  const { t } = useT();
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md sm:rounded-3xl" data-testid="voice-multi-sheet">
        <DialogHeader>
          <DialogTitle className="text-lg font-heading">
            {t("voiceFood.multiFound").replace("{n}", items.length)}
          </DialogTitle>
        </DialogHeader>
        <p className="text-[11px] text-slate-500 -mt-2">{t("voiceFood.multiHint")}</p>
        <ul className="mt-3 space-y-2">
          {items.map((it, i) => (
            <li key={i}>
              <button
                type="button"
                onClick={() => onPickItem?.(it, i)}
                data-testid={`voice-multi-item-${i}`}
                disabled={it.done}
                className={`w-full flex items-center gap-3 rounded-2xl border p-3 text-left transition ${
                  it.done
                    ? "bg-emerald-50 border-emerald-200 cursor-default"
                    : "bg-white border-slate-200 hover:border-[#FC9700] hover:shadow-sm"
                }`}
              >
                <span className={`h-9 w-9 rounded-full flex items-center justify-center shrink-0 ${
                  it.done ? "bg-emerald-600 text-white" : "bg-[#FC9700]/15 text-[#B36A00]"
                }`}>
                  {it.done ? <Check className="h-4 w-4" /> : <Search className="h-4 w-4" />}
                </span>
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-semibold text-slate-900 truncate">{it.query}</div>
                  <div className="text-[11px] text-slate-500 tabular-nums">
                    {it.quantity_g ? `${it.quantity_g} g` : it.pieces ? `${it.pieces}×` : t("voiceFood.tapToSearch")}
                  </div>
                </div>
              </button>
            </li>
          ))}
        </ul>
      </DialogContent>
    </Dialog>
  );
}
